import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import VehiclesContainer from '../vehicles/VehiclesContainer'

class VehiclesRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/vehicles" render={() => <VehiclesContainer />} />
      </Switch>
    )
  }
}

export default VehiclesRoutes



// WEBPACK FOOTER //
// ./src/containers/vehicles/routes/routes.js